import { get, post } from '@/utils/request'

export const registerUser = (params) => post('register', params)

export const getRsaKey = () => get('rsa_public_key')

export const login = data => post('login', data)

export const getInfo = () => get('profile')

export const editProfile = data => post('profile', data)

export const changePassword = data => post('change_password', data)

export const logout = () => get('logout')

export const getReporter = params => get('get_reporter', params)

export const getReporterDetail = async id => {
  const { data } = await get(`reporter/${id}`)
  return data
}
